import { Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks/hook";
import { dataFromApi } from "../redux/getApiData/reducer";
import { useTranslation } from "react-i18next";
import SystemCredentials from "../components/admin-pages/SystemCredentials";
import { ADMIN_TYPE, ROUTES } from "../constant";
import { AdminCollectorsPage } from "../components/admin-pages/AdminCollectorsPage";
import { AdminUserPermissionPage } from "../components/admin-pages/AdminUserPermissionPage";

export function Administration() {
  const { pathname } = useLocation();
  const apiData = useAppSelector(dataFromApi);
  const { t } = useTranslation();

  // Check if the user can admin page
  const hasPermission = () => {
    if (!apiData?.allowedAdministration) return false;
    return apiData.allowedAdministration.includes(Object.values(ADMIN_TYPE).find(item => item.PATH === pathname)?.PERMISSION);
  };

  if (!hasPermission() && apiData?.allowedAdministration) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        {t("cannotLoadAdministration")}
      </div>
    );
  }

  return (
    <div style={{width: "100%"}}>
      {pathname === ROUTES.ADMIN.USER_PERMISSIONS && (
        <AdminUserPermissionPage />
      )}

      {pathname === ROUTES.ADMIN.SYSTEM_CREDENTIALS && (
        <SystemCredentials />
      )}

      {pathname === ROUTES.ADMIN.COLLECTORS && (
        <AdminCollectorsPage />
      )}
    </div>
  );
}